export type RecordStatus = 'unreviewed' | 'false_positive' | 'true_positive' | 'inconclusive';

interface RecordStatusPresentation {
  label: string;
  button: string;
  pill: string;
  row: string;
}

export const RECORD_STATUSES: Record<RecordStatus, RecordStatusPresentation> = {
  unreviewed: {
    label: 'Unreviewed',
    button: 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50',
    pill: '',
    row: '',
  },
  false_positive: {
    label: 'False positive',
    button: 'border-green-600 bg-green-50 text-green-700 hover:bg-green-100',
    pill: 'bg-green-50 text-green-700',
    row: 'bg-green-500/10',
  },
  true_positive: {
    label: 'True positive',
    button: 'border-red-600 bg-red-50 text-red-700 hover:bg-red-100',
    pill: 'bg-red-50 text-red-700',
    row: 'bg-red-500/10',
  },
  inconclusive: {
    label: 'Inconclusive',
    button: 'border-amber-600 bg-amber-50 text-amber-700 hover:bg-amber-100',
    pill: 'bg-amber-50 text-amber-700',
    row: 'bg-amber-500/10',
  },
};

// Declaration order above is the click order the button cycles through.
const CYCLE = Object.keys(RECORD_STATUSES) as RecordStatus[];

export function nextRecordStatus(current: RecordStatus = 'unreviewed'): RecordStatus {
  return CYCLE[(CYCLE.indexOf(current) + 1) % CYCLE.length];
}

export function toRecordStatus(value: unknown): RecordStatus | null {
  return typeof value === 'string' && (CYCLE as string[]).includes(value)
    ? (value as RecordStatus)
    : null;
}

export function recordStatusAction(status: RecordStatus): string {
  return `Source status: ${RECORD_STATUSES[status].label}. Activate for ${RECORD_STATUSES[nextRecordStatus(status)].label}. Only you can see this.`;
}
